<template>
  <w-flex justify-center align-center v-if="$zutil.role('Pentadbir Sistem')">
    <div class="w-card__content content-hardcode">
        <w-flex class="mt3">
         <div class="xs11 text-right" >
          <w-button dark class="green--bg ml1" @click="add()">
             <w-icon class="mr1">fal fa-plus</w-icon> Tambah
         </w-button>
       </div>
      </w-flex>
    </div>
  </w-flex>
  <div class="w-table-wrap" >
    <table class="w-table" color="light" >
      <thead>
        <tr>
          <th class="w-table__header  text-left" width="1%">No</th>
          <th class="w-table__header  text-left">Tarikh</th>
          <th class="w-table__header  text-left">Pegawai</th>
          <th class="w-table__header  text-left">Vulva</th>
          <th class="w-table__header  text-left">Ambing Susu</th>
          <th class="w-table__header  text-left">Puting</th>
          <th class="w-table__header  text-left" width="1%">Tindakan</th>
        </tr>
      </thead>

      <tbody>
        <template v-if="datas.length == 0">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in datas">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" >{{ind+1}}</td>
            <td class="w-table__cell text-left" >{{dt.tarikh}}</td>
            <td class="w-table__cell text-left" >{{dt.user}}</td>
            <td class="w-table__cell text-left" >{{dt.vulva}}<br><template v-if="dt.vulva == 'Abnormal'">({{dt.vulva_catatan}})</template></td>
            <td class="w-table__cell text-left" >{{dt.ambing}}<br><template v-if="dt.ambing == 'Abnormal'">({{dt.ambing_catatan}})</template></td>
            <td class="w-table__cell text-left" >{{dt.puting}}<br><template v-if="dt.puting == 'Abnormal'">({{dt.puting_catatan}})</template></td>
            <td class="w-table__cell text-left" >
              <w-button class="fs-2" bg-color="error-dark1" dark tile @click="padam(dt)">
                <w-icon xs class="mr2">fal fa-trash</w-icon> Padam
              </w-button>
            </td>
            
          </tr>
        </template>
      </tbody>
    </table>
  </div>
  <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent"  
    :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
      <!-- <w-icon class="mr2">fal fa-list</w-icon> -->
       Tambah Fertiliti
    </template>
    <w-form  ref="form"  v-model="dialog.valid" @validate="submit" @success="success" >
      <z-input label="Tarikh *" type="date" v-model="form.tarikh"  :validators="[validators.required]" />
      <br>
      <div class="spacer">Vulva * :</div>
      <div class="spacer"></div>
      <br>
      <w-radios v-model="form.vulva" :items="jenis" inline :validators="[validators.required]"/>
      <template v-if="form.vulva !=1">
        <w-textarea 
          outline 
          label="Catatan*"
          placeholder="Jika Abnormal, Sila Nyatakan"
          class="mt3"
          name="vulva_catatan"
          v-model="form.vulva_catatan"
          type="text-area"
          :validators="[validators.required]"/>
      </template>
      <br>
      <div class="spacer">Ambing Susu * :</div>
      <div class="spacer"></div>
      <br>
      <w-radios v-model="form.ambing" :items="jenis" inline :validators="[validators.required]"/>
      <template v-if="form.ambing !=1">
        <w-textarea 
          outline 
          label="Catatan*"
          placeholder="Jika Abnormal, Sila Nyatakan"
          class="mt3"
          name="ambing_catatan"
          v-model="form.ambing_catatan"
          type="text-area"
          :validators="[validators.required]"/>
      </template>
      <br>
      <div class="spacer">Puting * :</div>
      <div class="spacer"></div>
      <br>
      <w-radios v-model="form.puting" :items="jenis" inline :validators="[validators.required]"/>
      <template v-if="form.puting !=1">
        <w-textarea 
          outline 
          label="Catatan*"
          placeholder="Jika Abnormal, Sila Nyatakan"
          class="mt3"
          name="puting_catatan"
          v-model="form.puting_catatan"
          type="text-area"
          :validators="[validators.required]"/>
      </template>
    </w-form>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="tutupmodal()">Tutup</w-button>
      <w-button class="my1" type="submit" @click="submit()">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> Simpan
      </w-button>
    </template>
  </w-dialog>


</template>

<script>
export default {
  name: "Pemilik",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'ternakan',
      form : {},
      datas : [],
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      jenis:[
        {value: 1, label: "Normal"},
        {value: 2, label: "Abnormal"}
      ],
      validators: {
          required: (value) => !!value || "Medan ini wajib diisi",
          consent: (value) => !!value || "You must agree",
          email: (value) =>
              !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
              "Sila Semak Format Email",
          numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
      },
      
    }
  },
  methods:{
    add(){
      this.form = {
           id : null,
           tarikh : '',
           vulva : null,
           vulva_catatan:'',
           ambing: null,
           ambing_catatan: '',
           puting: null,
           puting_catatan: '',
           catatan : '',
           ternakan_id: '',
      }
      this.dialog.show = true
      this.form.saveButton = "Save"
    },
    submit(){
      
      this.form.ternakan_id = this.data.ternakan_id;
      if (this.data.ternakan_id > 0) 
      {
        this.$zcomm.add(this.resourceurl + '.fertiliti_betina', this.form)
        .then(res => {
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
          this.$zutil.notify("Berjaya disimpan");
          this.dialog.show = false;
          this.getData();
        })
      }
    },
    padam(dt){
      if (confirm('Adakah anda pasti untuk memadam rekod ini?')) {
            this.$zcomm.delete(this.resourceurl + '.fertiliti_betinad', dt.id)
                .then(res => {
                  //update displayed record
                  this.$zutil.notify("Berjaya dipadam", false);
                  this.getData();
                  // this.$inertia.visit(this.$page.url)
                  // this.removeitem(res) // remove the data from list. no need to refresh page
                  if (typeof this.onAfterDelete === "function") {
                    this.onAfterDelete()
                  }
                })
                .finally(() => {
                  // $('#' + this.resourceurl).modal('hide')
                });
        }
    },
    tutupmodal(){
      this.dialog.show= false
    },
    getData(){
      this.$zcomm.get(this.api_service + 'ternakan/ferteliti_betina/'+this.data.ternakan_id, {}).then(res => {
        this.datas = res
      })
    },
    
  },
      
  mounted() {
    this.getData()
    
  }
}
      

</script>  
